// Centralized deep-link resolver — ONE type->route scheme shared by Atlas citations,
// notifications, Decisions, Missions and record links. The backend returns absolute
// paths in `link`; this mirrors that scheme so a future native client maps the same
// types to screens instead of re-deriving routes. Keep in sync with backend LINK_MAP.
export const LINK_ROUTES = {
  organization: (id) => `/crm/organizations/${id}`,
  person: () => `/crm/people`,
  opportunity: () => `/crm/opportunities`,
  project: (id) => `/tactics/projects/${id}`,
  task: (id) => `/work/items/${id}`,
  item: (id) => `/inventory/items/${id}`,
  inventory_item: (id) => `/inventory/items/${id}`,
  campaign: (id) => `/marketing/campaigns/${id}`,
  knowledge: () => `/knowledge`,
  decision: () => `/decisions`,
  mission: () => `/missions`,
  conversation: () => `/atlas`,
  agent: () => `/employee-zero/my-agents`,
};

// Prefer a backend-provided absolute path; otherwise resolve from type+id.
export function resolveLink(link, type, id) {
  if (link) return link;
  const fn = LINK_ROUTES[type];
  return fn ? fn(id) : null;
}
